import { useNavigate, useLocation } from 'react-router-dom';
import { UserBriefInfo } from '@spilca/accounting_ts/v1/auth_common/dtos_pb';
import { Button, BUTTON_INTENT } from '@monorepo/ui-kit';
import { useI18n } from '@monorepo/i18n';
import { Icon } from '@monorepo/icons';
import { useUser } from '../../index';
import MerchandiserItem from './components/MerchandiserItem';
import styles from './index.module.css';

const UserMerchandisersListFO = () => {
  const { data: user, isLoading: isUserLoading } = useUser();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useI18n();

  // While user data is loading
  if (isUserLoading) {
    return <div>Loading...</div>;
  }

  // If user has limited access → block page
  if (user?.isLimited) {
    return (
      <div className={styles.emptyList}>
        {t('uitext.no_permission_to_view_page')}
      </div>
    );
  }

  // If user is loaded and has permission
  if (user) {
    return (
      <>
        {user.employeesList.length === 0 && (
          <div className={styles.emptyList}>{t('merchandisersList.empty')}</div>
        )}
        <table className={styles.container}>
          <tbody>
            {user.employeesList.map((item: UserBriefInfo.AsObject) => (
              <MerchandiserItem key={item.id} item={item} />
            ))}
          </tbody>
        </table>
        <Button
          intent={BUTTON_INTENT.tertiary}
          isOnlyIcon
          onClick={() => navigate(`${pathname}/add`)}
          className={styles.addButton}
        >
          <Icon name="plus_round" className={styles.iconPlus} />
          {t('personalInfo.form.add')}
        </Button>
      </>
    );
  }

  // Fallback (if no user)
  return null;
};

export default UserMerchandisersListFO;
